<template>

    <Page>
   
        <div class="grid grid-cols-2 justify-center items-center scale-90">

            <Video class="scale-150 mt-8"
                src="~/video/protect.mp4" 
                title="Watch Video" 
            />

            <div class="flex flex-col items-center gap-4">
            
                <Image src="/Carnex-Protect.png"
                    class="h-24 -top-4" 
                />

                <div class="text-center text-sm 2xl:text-base font-semibold uppercase 
                            opacity-80 px-8 -top-8">
                    Revenue Today &middot; More Revenue Tomorrow
                </div>

                <Image
                    src="/WhatIsCarbucks/carnex-protect-brochure.png"
                    class="w-[50vw] md:w-full max-w-[420px] mb-6 mx-auto 2xl:-top-4 2xl:-mb-2"
                    floor-shadow
                />

            </div>

        </div>

    </Page>

</template>